import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Switch } from '../../Components/Form';
import { useSubscription } from '../../Data/Marketplace';
import { PageLoading } from '../../Components/Loading';

const LeadGeneration = ({isOpen, setIsOpen, onChange}) => {
    return <Modal title="Lead Generation" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{onChange}} />}
    </Modal>
}

const Inner = ({onChange}) => {
    const {subscription, isLeadGenActive, updateLeadGeneration} = useSubscription();

    if (!subscription) {
        return <PageLoading />;
    }
console.log('isLeadGenActive', isLeadGenActive)
    return <>
        <div className="prose-sm mb-4">
            <p>
                Lead generation allows you to easily grow your round.
            </p>

            <p>
                When you enable lead generation we'll start online canvassing in your area to bring in more leads,
                and any new leads in your patch will be automatically purchased for you.
            </p>

            <p>
                Leads are sold exclusively to you, as always.
            </p>

            <p>
                To keep lead generation running just keep your balance above 15 lead credits.
            </p>
        </div>

        <Form data={{autoPurchase: isLeadGenActive}}
            onSubmit={updateLeadGeneration}
            afterSubmit={onChange}
            closeModalOnSubmit
        >
            <Switch name="autoPurchase"
                label="Enable lead generation"
                disabled={!isLeadGenActive}
                help={isLeadGenActive ? '' : 'Sorry, we\'re not currently offering lead generation in your area.'}
            />
            <Actions submit={{label: 'Save'}} cancel />
        </Form>
    </>
}

export default LeadGeneration;
